/*                               Schema Entities                              */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const entity = new schema.Entity('entities', {}, { idAttribute: 'entityTypeId' });
export const entities = new schema.Array(entity);
